<template>
  <v-container class="app-container--width-max">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <StepperBase :sections="form.sections" v-if="!overlay" />
  </v-container>
</template>

<script>
import { getNamePagePaymentByJourney } from "@/common/navigating";
import { applyThirdPartyId } from "@/common/utils";
import StepperBase from "@/components/Steppers/StepperBase";
import {
  APPLICATION_MODULE,
  QUESTIONS_MODULE,
  STEPS_MODULE,
} from "@/store/types/module-types";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "ApplicationMain",
  data() {
    return {
      overlay: false,
    };
  },
  components: {
    StepperBase,
  },
  props: {
    paymentStatus: String,
  },
  computed: {
    ...mapState(APPLICATION_MODULE, ["form", "applyResponse"]),
    ...mapState(QUESTIONS_MODULE, ["userId"]),
    ...mapGetters(APPLICATION_MODULE, [
      "secondApplicantSection",
      "selectedQuote",
    ]),
    ...mapGetters(QUESTIONS_MODULE, [
      "getBoolAnswer",
      "isSelfServe",
      "productId",
    ]),
    ...mapState(STEPS_MODULE, ["paymentDetailStep"]),
    secondAppInc() {
      return this.getBoolAnswer("SecondApplicantIncluded");
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["fetchQuoteExcessConfiguration"]),
    ...mapActions(APPLICATION_MODULE, [
      "setQuoteId",
      "retrieveQuoteByQuoteRequestIdFollowingCancelledCardPayment",
      "repopulateActiveQuoteFromSessionStorage",
      "repopulateCommissionSacrifice",
      "setCardPaymentStatus",
    ]),
    ...mapActions(STEPS_MODULE, ["handleGoStep"]),
    setSecondApp() {
      this.secondApplicantSection.IsVisible = this.secondAppInc;
    },
    retrieveQuoteFollowingCancelledCardPayment() {
      const quoteRequestId = sessionStorage.getItem("quoteRequestId");
      return this.retrieveQuoteByQuoteRequestIdFollowingCancelledCardPayment(
        quoteRequestId
      );
    },
    async initData() {
      await this.fetchQuoteExcessConfiguration();
      if (
        this.paymentStatus !== "cancelled" &&
        this.paymentStatus !== "failed"
      ) {
        this.setSecondApp();
        return;
      }

      this.overlay = true;
      try {
        this.setCardPaymentStatus(this.paymentStatus);
        await this.retrieveQuoteFollowingCancelledCardPayment();
        this.repopulateActiveQuoteFromSessionStorage();
        this.repopulateCommissionSacrifice();
        applyThirdPartyId(this.isSelfServe, this.userId);

        const paymentPageName = getNamePagePaymentByJourney();
        if (paymentPageName) {
          this.$router.push({
            name: paymentPageName,
          });
          return;
        }
        this.handleGoStep(this.paymentDetailStep);
        this.setSecondApp();
      } finally {
        this.overlay = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
